(function () {
  const revealClass = 'global-anim-reveal';
  const visibleClass = 'is-global-visible';
  const sectionSelector = '#MainContent .shopify-section, #MainContent .section, #MainContent [id^="shopify-section-"]';
  const skipSelector = 'script, style, link, noscript, template, input, select, textarea, option';

  function unique(elements) {
    return Array.from(new Set(elements.filter(Boolean)));
  }

  function addReveal(element, order, motion) {
    if (!element || element.matches(skipSelector)) return;
    if (element.classList.contains(revealClass) || element.classList.contains('y486-reveal')) return;
    element.classList.add(revealClass);
    element.style.setProperty('--global-animation-order', order || 0);
    if (motion) element.dataset.globalMotion = motion;
  }

  function selectIn(root, selector) {
    return Array.from(root.querySelectorAll(selector)).filter((item) => {
      return item.offsetParent !== null || item.getClientRects().length > 0;
    });
  }

  function classifySection(section) {
    const text = section.className || '';
    const id = section.id || '';
    const signature = `${text} ${id}`.toLowerCase();

    if (signature.includes('mainproduct') || signature.includes('featured-product') || section.querySelector('.main-product')) return 'product';
    if (signature.includes('slideshow') || signature.includes('banner') || section.querySelector('.slideshow, .hero-banner, .image-with-text-overlay')) return 'hero';
    if (signature.includes('faq') || section.querySelector('faq-item, .faq-section-items, .accordion-item, collapsible-block')) return 'faq';
    if (signature.includes('collection') || section.querySelector('.collection-item, .product-item, product-card, .product-card')) return 'grid';
    if (signature.includes('icon-box') || section.querySelector('.sec__icon-box-item')) return 'icon';
    if (signature.includes('rich-text') || section.querySelector('.rich__text, .section__header')) return 'text';
    if (section.querySelector('.ai-marquee-carousel__track, [data-marquee-track]')) return 'marquee';
    if (section.querySelector('.image-with-text, [class*="image-text"]')) return 'split';
    return 'default';
  }

  function animateProductSection(section) {
    addReveal(section.querySelector('.product-detail__media'), 0, 'zoom');
    addReveal(section.querySelector('.product-detail__information'), 1, 'right');

    selectIn(section, '.product-detail__information > *:not(.sticky), .product-detail__information .sticky > *').slice(0, 12).forEach((item, index) => {
      addReveal(item, index + 1, 'pop');
    });
  }

  function animateHeroSection(section) {
    selectIn(section, 'img, picture, .hero-img, .slide-img').slice(0, 2).forEach((item, index) => {
      item.classList.add('global-anim-image');
      addReveal(item, index, 'zoom');
    });

    selectIn(section, '.section__header, .hero-text, .sec__content, .banner-content, h1, h2, h3, p, .button, .btn').slice(0, 8).forEach((item, index) => {
      addReveal(item, index + 1, 'fade');
    });
  }

  function animateGridSection(section) {
    selectIn(section, '.section__header, h1, h2, h3').slice(0, 3).forEach((item, index) => {
      addReveal(item, index, 'fade');
    });

    selectIn(section, '.product-item, .collection-item, .grid-custom-item, .card, product-card, .product-card, .blog-posts-item').slice(0, 24).forEach((item, index) => {
      addReveal(item, index + 1, 'pop');
    });
  }

  function animateFaqSection(section) {
    selectIn(section, '.section__header, .section__header-heading, .section__header-des').forEach((item, index) => {
      addReveal(item, index, 'fade');
    });

    selectIn(section, '.faq-section-items, .accordion-item, collapsible-block, faq-item > *, .bls-toggle').slice(0, 32).forEach((item, index) => {
      addReveal(item, index + 1, 'pop');
    });
  }

  function animateIconSection(section) {
    selectIn(section, '.section__header, h2, h3').slice(0, 3).forEach((item, index) => {
      addReveal(item, index, 'fade');
    });

    selectIn(section, '.sec__icon-switch-slide, .sec__icon-box-item, .icon_box, [class*="icon-box"]').slice(0, 16).forEach((item, index) => {
      addReveal(item, index + 1, 'pop');
    });
  }

  function animateSplitSection(section) {
    const media = selectIn(section, 'img, picture, .image-with-text__image, [class*="image-wrapper"]').slice(0, 3);
    const content = selectIn(section, '.image-with-text__text, [class*="content"], .rich__text-m0, h2, h3, p').slice(0, 6);

    media.forEach((item, index) => {
      item.classList.add('global-anim-image');
      addReveal(item, index, 'left');
    });

    content.forEach((item, index) => addReveal(item, index + 1, 'right'));
  }

  function animateTextSection(section) {
    selectIn(section, '.section__header, h1, h2, h3, p, .rte, .rich__text-m0, .sec__content-btn').slice(0, 12).forEach((item, index) => {
      addReveal(item, index, 'fade');
    });
  }

  function animateMarqueeSection(section) {
    selectIn(section, 'h1, h2, h3, .section__header').slice(0, 3).forEach((item, index) => addReveal(item, index, 'fade'));
    selectIn(section, '[data-marquee-track], [class*="marquee"][class*="track"]').forEach((item) => {
      item.classList.add('global-anim-marquee');
      addReveal(item, 1, 'fade');
    });
  }

  function animateDefaultSection(section) {
    const primary = selectIn(section, '.section__header, h1, h2, h3, p, img, picture, .button, .btn, .grid > *, .flex > *').slice(0, 18);
    primary.forEach((item, index) => {
      if (item.matches('img, picture')) item.classList.add('global-anim-image');
      addReveal(item, index, item.matches('img, picture') ? 'zoom' : 'pop');
    });
  }

  function prepareSection(section) {
    if (!section || section.dataset.globalAnimationReady === 'true') return;
    section.dataset.globalAnimationReady = 'true';

    const type = classifySection(section);
    if (type === 'product') animateProductSection(section);
    else if (type === 'hero') animateHeroSection(section);
    else if (type === 'faq') animateFaqSection(section);
    else if (type === 'grid') animateGridSection(section);
    else if (type === 'icon') animateIconSection(section);
    else if (type === 'split') animateSplitSection(section);
    else if (type === 'text') animateTextSection(section);
    else if (type === 'marquee') animateMarqueeSection(section);
    else animateDefaultSection(section);
  }

  function revealAllIn(root) {
    selectIn(root, `.${revealClass}`).forEach((item) => item.classList.add(visibleClass));
  }

  function observeReveals(root) {
    const items = selectIn(root || document, `.${revealClass}:not(.${visibleClass})`);
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add(visibleClass));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(visibleClass);
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -55px 0px',
      threshold: 0.06,
    });

    items.forEach((item) => observer.observe(item));
  }

  function initGlobalSectionAnimations(root) {
    const scope = root || document;
    const sections = unique(Array.from(scope.querySelectorAll(sectionSelector)));
    sections.forEach(prepareSection);
    observeReveals(scope);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initGlobalSectionAnimations(document);

    document.addEventListener('click', (event) => {
      const tabButton = event.target.closest('.tab-button[data-tab], .tab-button[data-panel]');
      if (!tabButton) return;
      const panelId = tabButton.dataset.tab || tabButton.dataset.panel;

      setTimeout(() => {
        const panel = document.getElementById(panelId);
        if (!panel) return;
        selectIn(panel, `.${revealClass}`).forEach((item) => {
          item.classList.remove(visibleClass);
          void item.offsetWidth;
          item.classList.add(visibleClass);
        });
      }, 80);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initGlobalSectionAnimations(event.target);
    revealAllIn(event.target);
  });
})();
